<progress [max]="max" [value]="value" [class]="color()!"></progress>
